import { ReactNode } from 'react';
import { Text } from '@ardoq/typography';
import { FlexBox, Stack } from '@ardoq/layout';

interface DoqyWithMessageProps {
  children: ReactNode;
}
export const DoqyWithMessage = ({ children }: DoqyWithMessageProps) => (
  <FlexBox
    width="full"
    align="center"
    justify="center"
    height="full"
    padding="medium"
  >
    <Text variant="text2">
      <Stack gap="small" align="center" justify="center">
        {children}
      </Stack>
    </Text>
  </FlexBox>
);
